import { render, staticRenderFns } from "./LeaguesListTable.vue?vue&type=template&id=5aa9b136&"
import script from "./LeaguesListTable.vue?vue&type=script&lang=ts&"
export * from "./LeaguesListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports